import React, { useEffect, useState } from 'react';
import { CircularProgressbarWithChildren, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

const FancyScore = ({ score = 3.7, label = 'My Score' }) => {
    const [animatedValue, setAnimatedValue] = useState(0);

    useEffect(() => {
        let start = 0;
        const end = score;
        const duration = 800; // ms
        const stepTime = 10;
        const steps = duration / stepTime;
        const increment = (end - start) / steps;

        const interval = setInterval(() => {
            start += increment;
            if (start >= end) {
                start = end;
                clearInterval(interval);
            }
            setAnimatedValue(parseFloat(start.toFixed(2)));
        }, stepTime);

        return () => clearInterval(interval);
    }, [score]);

    const percentage = (animatedValue / 5) * 100;

    const getColor = () => {
        if (animatedValue <= 2) return '#FF4D4F';
        if (animatedValue <= 3) return '#FFA940';
        if (animatedValue <= 4) return '#FAAD14';
        if (animatedValue <= 4.5) return '#73D13D';
        return '#52C41A';
    };

    return (
        <div style={{
            width: 120,
            height: 120,
            margin: '20px auto',
            background: 'radial-gradient(circle at center, #f9f9f9, #e0e0e0)',
            borderRadius: '50%',
            padding: '0px',
            boxShadow: '0 6px 20px rgba(0,0,0,0.1)'
        }}>
            <CircularProgressbarWithChildren
                value={percentage}
                strokeWidth={12}
                styles={buildStyles({
                    pathColor: getColor(),
                    trailColor: '#d9d9d9',
                })}
            >
                <div style={{ textAlign: 'center' }}>
                    <div style={{ fontSize: '11px', fontWeight: '600', color: '#888' }}>{label}</div>
                    <div style={{ fontSize: '28px', fontWeight: 'bold', color: getColor() }}>
                        {animatedValue.toFixed(1)}
                    </div>
                    <div style={{ fontSize: '11px', color: '#aaa' }}>(out of 5)</div>
                </div>
            </CircularProgressbarWithChildren>
        </div>
    );
};

export default FancyScore;
